export default function ConfirmModal({
  title,
  message,
  onConfirm,
  onCancel,
  loading,
}) {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{title || "Are you sure?"}</h3>
        <p>{message || "This action cannot be undone."}</p>
        <div className="modal-actions">
          <button
            className="btn btn-outline"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
